import * as type from './type';
export default {
    [type.SET_WARES](state, wares) {
        state.wares = wares;
    },
    [type.SET_PURCHASE_ORDER_NUMBER](state, purchaseNum) {
        state.purchaseNum = purchaseNum;
    },
    [type.SET_SUCCESS_ORDER_LIST](state, successOrderList) {
        state.successOrderList = successOrderList;
    },
    [type.SET_CONFIRM_MSG](state, msg) {
        state.msg = msg;
    },
    [type.SET_ERR_LIST](state, errList) {
        state.errList = errList;
    },
    [type.SET_HAS_ERR](state, hasErr) {
        state.hasErr = hasErr;
    },
    [type.SET_COMPANY_NAME](state, companyName) {
        state.companyName = companyName;
    },
    [type.SET_TAXPAYER_NUM](state, taxpayerNumber) {
        state.taxpayerNumber = taxpayerNumber;
    }
}


// WEBPACK FOOTER //
// ./src/store/confirm/mutations.js